/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { connect } from "react-redux";
import { CollectionLayout } from "./section";

const CollectionPageBase = props => {
  return <CollectionLayout {...props} />;
};

function mapStateToProps(state) {
  return {
    config: state.qt.config
  };
}

export const CollectionPage = connect(mapStateToProps)(CollectionPageBase);
